import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Indeterminate activity spinner — the border-ring idiom used across the app,
 * as one component instead of per-template spans. The host element IS the
 * ring: size it with `[size]` (px) and color it with a text-* class on the
 * tag (`currentColor` paints the ring), e.g.
 *
 *   <app-spinner [size]="16" class="text-ink-3" />
 *
 * Decorative only (aria-hidden); pair it with visible text or an aria-label
 * on the surrounding element when the wait needs announcing.
 */
@Component({
  selector: 'app-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  host: {
    class: 'inline-block flex-none animate-spin rounded-full border-2 border-current border-t-transparent',
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()',
    'aria-hidden': 'true',
  },
})
export class Spinner {
  /** Diameter in px. */
  readonly size = input(20);
}
